const Projects = (props) => {
  return (
    <div>
      <h3>Projects - page </h3>
    </div>
  );
}
export default Projects;